import h from 'hyperscript';
import { t } from 'javascripts/utils/withTranslation';
import { generateIcon as icon } from 'components/_particles/icon/icon';
import Swipe from 'javascripts/utils/Swipe';
import { MEDIA_QUERIES } from 'javascripts/constants';

export default class TeaserSlider {
  constructor($teaserSlider, mq, config) {
    this.config = config;
    this.$teaserSlider = $teaserSlider;

    if (this.config) {
      this.$inner = this.$teaserSlider.querySelector(this.config.inner);
      this.$teasersContainer = this.$teaserSlider.querySelector(this.config.teasersContainer);
      this.$teaserWrappers = this.$teaserSlider.querySelectorAll(this.config.teaserWrappers);
    } else {
      this.$inner = this.$teaserSlider.querySelector('.teaser-slider__inner');
      this.$teasersContainer = this.$teaserSlider.querySelector('.teaser-slider__teasers');
      this.$teaserWrappers = this.$teaserSlider.querySelectorAll('.teaser-slider__teaser');
    }

    this.numberOfSlides = this.$teaserWrappers.length;
    this.hasFiveSlides = this.$teaserSlider.classList.contains('teaser-slider--five');
    this.hasThreeSlides = this.$teaserSlider.classList.contains('teaser-slider--three');
    this.hasOneSlide = this.$teaserSlider.classList.contains('teaser-slider--one');
    this.isDesktop = mq.matches;
    this.activeIndex = 0;
    this.itemsToScroll = this.getItemsToScroll();
    this.itemsVisible = this.getItemsVisible();
    this.maxIndex = this.getMaxIndex();
    this.slideWidth = this.getActiveSlideWidth();

    this.initControls();
    this.initEvents();
  }

  deconstructor() {
    this.removeArrows();
    this.removeDots();
    this.deinitSwiping();
    window.removeEventListener('resize', this.handleResize);
  }

  initControls() {
    if (!this.isDesktop) {
      if (this.itemsToScroll < this.$teaserWrappers.length) {
        this.renderDots();
      }
      this.initSwiping();
    }
    this.updateArrows();
  }

  initEvents() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('selectTab', () => {
      this.slideWidth = this.getActiveSlideWidth();
    });
    if (this.$teasersContainer) {
      this.$teasersContainer.addEventListener('focusin', this.focusIn);
      this.$teasersContainer.addEventListener('mousedown', () => { this.mousedown = true; });
      this.$teasersContainer.addEventListener('mouseup', () => { this.mousedown = false; });
      window.addEventListener('focusin', () => { this.mousedown = false; });
      window.addEventListener('blur', () => { this.mousedown = true; });
    }
  }

  focusIn = (event) => {
    if (event.target && !this.mousedown) {
      const className = this.$teaserWrappers[0].classList[0];
      this.$inner.scrollLeft = 0;
      const $slide = event.target.closest(`.${className}`);
      const index = Array.prototype.indexOf.call(this.$teaserWrappers, $slide);
      this.activeIndex = index;
      if (this.activeIndex < this.maxIndex) {
        this.updateTeaserPosition();
        this.updateArrows();
        if (!this.isDesktop) {
          this.updateDots();
        }
      }
    }
  }

  initSwiping = () => {
    this.swipe = new Swipe(this.$teasersContainer);
    this.swipe.onLeft(this.handleOnLeftSwipe);
    this.swipe.onRight(this.handleOnRightSwipe);
  }

  deinitSwiping = () => {
    if (this.swipe && this.swipe.deconstructor) {
      this.swipe.deconstructor();
    }
  }

  handleOnLeftSwipe = () => {
    if (this.activeIndex < this.maxIndex) {
      let scrollToIndex = this.maxIndex;
      if (this.activeIndex < this.maxIndex) {
        scrollToIndex = this.activeIndex + this.itemsToScroll;
      }
      this.activeIndex = scrollToIndex;
      this.updateTeaserPosition();
    }
    this.updateDots();
    this.updateArrows();
  }

  handleOnRightSwipe = () => {
    if (this.activeIndex > 0) {
      let scrollToIndex = this.activeIndex - 1;
      if (this.activeIndex >= this.itemsToScroll) {
        scrollToIndex = this.activeIndex - this.itemsToScroll;
      }
      this.activeIndex = scrollToIndex;
      this.updateTeaserPosition();
    }
    this.updateDots();
    this.updateArrows();
  }

  getMaxIndex = () => (this.$teaserWrappers.length - this.itemsToScroll) + 1;

  getActiveSlideWidth = () => this.$teaserWrappers[this.activeIndex].offsetWidth;

  handleResize = () => {
    this.activeIndex = 0;
    this.slideWidth = this.getActiveSlideWidth();
    this.itemsToScroll = this.getItemsToScroll();
    this.itemsVisible = this.getItemsVisible();
    this.maxIndex = this.getMaxIndex();
    this.updateTeaserPosition();

    if (!this.isDesktop) {
      if (this.itemsToScroll < this.$teaserWrappers.length) {
        this.renderDots();
      }
      this.updateArrows();
    }
  };

  removeArrows = () => {
    if (this.$controlNext && this.$controlNext.parentNode) {
      this.$controlNext.parentNode.removeChild(this.$controlNext);
    }

    if (this.$controlPrev && this.$controlPrev.parentNode) {
      this.$controlPrev.parentNode.removeChild(this.$controlPrev);
    }
  };

  removeDots = () => {
    if (this.$arrowDotWrapper && this.$arrowDotWrapper.parentNode) {
      this.$arrowDotWrapper.parentNode.removeChild(this.$arrowDotWrapper);
    }
  };

  prevTeaser = () => {
    if (this.activeIndex > 0) {
      this.activeIndex -= 1;
      this.updateTeaserPosition();
    }
  };

  nextTeaser = () => {
    if (this.activeIndex < this.maxIndex) {
      this.activeIndex += 1;
      this.updateTeaserPosition();
    }
  };

  updateTeaserPosition = () => {
    this.$teasersContainer.style.transform =
    `translateX(${-1 * this.activeIndex * this.slideWidth}px)`;
  };

  handleDotClick = (index) => {
    this.activeIndex = index;
    this.updateDots();
    this.updateTeaserPosition();
    this.updateArrows();
  };

  renderDots = () => {
    this.removeDots();

    const $dots = h('div.dots');

    if (this.$teaserWrappers.length > 1 && this.$teaserWrappers.length !== this.itemsToScroll) {
      this.$teaserWrappers.forEach((_, index) => {
        if (index % this.itemsToScroll === 0 ||
          index === 0 ||
          (index === this.maxIndex && index % this.itemsToScroll === 0)
        ) {
          const dotContent = h('span.u-hidden-visually', `${t('Zu Kachel')}: ${index}`);
          const dot = h(`button.dots__dot${index === this.activeIndex ? '.dots__dot--active' : ''}`, {
            type: 'button',
            tabIndex: '-1',
            onclick: () => this.handleDotClick(index),
          }, dotContent);
          const dotWrapper = h('.dots__dot-wrapper', dot);
          $dots.appendChild(dotWrapper);
        }
      });
      this.$dotsWrapper = h('div.teaser-slider__dots', $dots);
      this.$arrowDotWrapper = h('.teaser-slider__dot-arrows', this.$dotsWrapper);
      this.$inner.appendChild(this.$arrowDotWrapper);

      this.updateDots();
    }
  };

  updateDots = () => {
    let $activeDot = this.$dotsWrapper.querySelector('.dots__dot--active');
    const dotPositions = [];
    let spaceAdd = 0;

    this.$dotsWrapper.querySelectorAll('.dots__dot').forEach(($dot, index, $dots) => {
      // init dotPositions
      dotPositions[index] = -1 * spaceAdd;
      spaceAdd += $dot.parentNode.offsetWidth;
      // add active class
      if (index * this.itemsToScroll === this.activeIndex) {
        $dots.forEach($do => $do.classList.remove('dots__dot--active'));
        $dot.classList.add('dots__dot--active');
        $activeDot = $dot;
      }
    });
    // center
    const dotsToShow = 5;
    if (dotPositions.length > dotsToShow) {
      const containerCenter = this.$dotsWrapper.offsetWidth / 2;
      const itemCenter = $activeDot.parentNode.offsetWidth / 2;
      const dotsIndex = this.activeIndex / this.itemsToScroll;
      const centeredPosition = (dotPositions[dotsIndex] + containerCenter) - itemCenter;
      let finalPosition = centeredPosition;

      if (dotsIndex < dotsToShow - Math.ceil(dotsToShow / 2)) {
        finalPosition = 0;
      } else if (dotsIndex > dotPositions.length - Math.ceil(dotsToShow / 2)) {
        finalPosition = (dotPositions[dotPositions.length - Math.ceil(dotsToShow / 2)] +
          containerCenter) - itemCenter;
      }
      this.$dotsWrapper.querySelector('.dots').style.transform = `translateX(${finalPosition}px)`;
    } else {
      this.$dotsWrapper.classList.add('teaser-slider__dots--center');
    }
  }

  getItemsVisible() {
    if (this.hasOneSlide) {
      return 1;
    }

    const mqXl = window.matchMedia(MEDIA_QUERIES.xl);
    const mqM = window.matchMedia(MEDIA_QUERIES.m);

    // mobile
    let itemsVisible = 1;

    if (this.hasFiveSlides) {
      itemsVisible = 2;
    }

    // tablet
    if (mqM.matches) {
      itemsVisible = 2;

      if (this.hasFiveSlides) {
        itemsVisible = 3;
      }
    }

    // tablet landscape or small desktop
    if (mqXl.matches) {
      itemsVisible = 4;

      if (this.hasThreeSlides) {
        itemsVisible = 3;
      }

      if (this.hasFiveSlides) {
        itemsVisible = 5;
      }
    }

    return itemsVisible;
  }

  getItemsToScroll() {
    if (this.hasOneSlide) {
      return 1;
    }

    const mqXl = window.matchMedia(MEDIA_QUERIES.xl);
    const mqM = window.matchMedia(MEDIA_QUERIES.m);

    // mobile
    let itemsToScroll = 1;

    if (this.hasFiveSlides) {
      itemsToScroll = 2;
    }

    // tablet
    if (mqM.matches) {
      itemsToScroll = 2;

      // if (this.hasFiveSlides) {
      //   itemsToScroll = 3;
      // }
    }

    // tablet landscape or small desktop
    if (mqXl.matches) {
      itemsToScroll = 1;

      // if (this.hasFiveSlides) {
      //   itemsToScroll = 5;
      // }
    }

    return itemsToScroll;
  }

  handleLeftArrowClick = () => {
    if (!this.isDesktop) {
      this.handleOnRightSwipe();
    } else {
      this.prevTeaser();
    }
    this.updateArrows();
  }

  handleRightArrowClick = () => {
    if (!this.isDesktop) {
      this.handleOnLeftSwipe();
    } else {
      this.nextTeaser();
    }
    this.updateArrows();
  }

  updateArrows = () => {
    this.removeArrows();

    this.$controlPrev = h(
      'button.teaser-slider__arrow.teaser-slider__arrow--prev',
      {
        onclick: this.handleLeftArrowClick,
        type: 'button',
        tabIndex: '-1',
        attrs: {
          'aria-label': t('Vorheriger Teaser'),
        },
      },
      icon({
        icon: 'slider-arrow-left',
        viewBox: '0 0 70 200',
        className: 'slider__arrow-icon',
      }),
    );

    this.$controlNext = h(
      'button.teaser-slider__arrow.teaser-slider__arrow--next',
      {
        onclick: this.handleRightArrowClick,
        type: 'button',
        tabIndex: '-1',
        attrs: {
          'aria-label': t('Nächster Teaser'),
        },
      },
      icon({
        icon: 'slider-arrow-right',
        viewBox: '0 0 70 200',
        className: 'slider__arrow-icon',
      }),
    );

    const $container = this.isDesktop ? this.$inner : this.$arrowDotWrapper;

    if (this.activeIndex > 0) {
      $container.appendChild(this.$controlPrev);
    }

    if (this.activeIndex < (this.numberOfSlides - this.itemsVisible)) {
      $container.appendChild(this.$controlNext);
    }
  };
}
